import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ContactInfo from "../../../components/staff/profile/ContactInfo";
import EducationalInfo from "../../../components/staff/profile/EducationalInfo";
import EmploymentInfo from "../../../components/staff/profile/EmploymentInfo";
import GuarantorInfo from "../../../components/staff/profile/GuarantorInfo";
import NextOfKinInfo from "../../../components/staff/profile/NextOfKinInfo";
import PersonalInfo from "../../../components/staff/profile/PersonalInfo";
import PreviousPlaceOfWork from "../../../components/staff/profile/PreviousPlaceOfWork";
import PageTitle from "./../../../components/partials/PageTitle";
import {
  fetchAllStates,
  getStaffInformation,
  resetStaffStatus,
} from "../../../redux/slice/staff/staffSlice";
import { BeatLoader } from "react-spinners";
import ActivateAndDeactivateStaff from "../../../components/staff/profile/ActivateAndDeactivateStaff";
// import { flashMessage as flash } from './../../../utils/flash/index';
// import { useRef } from 'react';

function StaffProfile() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user_permissions } = useSelector((state) => state.auth?.user);
  const { staff_information, isUpdated, isSuccess } = useSelector(
    (state) => state?.staff
  );

  const breadcrumb = {
    from: {
      title: "Staff",
      link: "/admin/list-of-staffs",
    },
    current: {
      title: "Staff Profile",
      link: null,
    },
  };

  // useEffect(() => {
  //   !location?.state?.staff_id && navigate(-1);
  // }, []);

  // useEffect(() => {
  //     if(!window.location.hash) {
  //         window.location = window.location + '#';
  //         window.location.reload();
  //     }
  // },[])

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "staff module"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  //   if (!location?.state?.staff_id) {
  //     return <h4>Loading...</h4>;
  //   }

  useEffect(() => {
    dispatch(getStaffInformation(location?.state?.staff_id));
    dispatch(fetchAllStates());
  }, [isUpdated]);

  useEffect(() => {
    dispatch(resetStaffStatus());
  }, [isSuccess]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Staff List' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          {staff_information?.personal_information ? (
            <div className='card'>
              <div className='card-body'>
                <PersonalInfo />
                <ContactInfo />
                <EducationalInfo />
                <EmploymentInfo />
                <GuarantorInfo />
                <NextOfKinInfo />
                <PreviousPlaceOfWork />
                <ActivateAndDeactivateStaff />
              </div>
            </div>
          ) : (
            <div className='mt-2'>
              <BeatLoader
                height='80'
                width='80'
                radius='9'
                color='#2e3192'
                ariaLabel='three-dots-loading'
                visible={true}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default StaffProfile;
